declare const API_ENDPOINT: string;
declare const GAE_ENDPOINT: string;
declare const AMWEB_ENDPOINT: string;
const _API_ENDPOINT = API_ENDPOINT;
const _GAE_ENDPOINT = GAE_ENDPOINT;
const _AMWEB_ENDPOINT = AMWEB_ENDPOINT;
export { _API_ENDPOINT as API_ENDPOINT };
export { _GAE_ENDPOINT as GAE_ENDPOINT };
export { _AMWEB_ENDPOINT as AMWEB_ENDPOINT };
